
import { useState, useEffect, useMemo } from "react";
import { markGameCompleted, saveGameResult, setViewingResults } from "@/lib/storage/local-storage";
import type { GameResult } from "@/hooks/useGameFlow";
import type { DailyPuzzle } from "@/lib/types/game";

export function useGameResultState(gameResult: GameResult, puzzle: DailyPuzzle) {
  const [vetoDialogOpen, setVetoDialogOpen] = useState(false);
  const [showCountdown, setShowCountdown] = useState(false);
  const [reasoningModalOpen, setReasoningModalOpen] = useState(false);
  
  const currentResult = useMemo(() => {
    const resultWithDate = {
      ...gameResult,
      completedDate: gameResult.completedDate || puzzle?.date
    };
    
    if (resultWithDate.completedDate && puzzle?.date === resultWithDate.completedDate) {
      markGameCompleted(resultWithDate.completedDate);
      saveGameResult(resultWithDate);
    }
    
    return resultWithDate;
  }, [gameResult, puzzle]);
  
  useEffect(() => {
    console.log("GameResultScreen mounted with:", {
      result: currentResult.result,
      solveTime: currentResult.solveTime,
      puzzleDate: puzzle.date,
      hasSelectedWords: currentResult.selectedWords.length > 0,
      hasLinks: !!puzzle.wordLinks,
      wordLinks: puzzle.wordLinks
    });
    
    setViewingResults(true);
  }, [puzzle, currentResult]);

  return {
    vetoDialogOpen,
    setVetoDialogOpen,
    showCountdown,
    setShowCountdown,
    reasoningModalOpen,
    setReasoningModalOpen,
    currentResult
  };
}
